import MainContainer from "../../../components/MainContainer";
import { headerPersonnalEvalutaion } from "../../../data/modules/personnal-evaluation-header";
import MesEquipesPage from "./pages/MesEquipesPage";

export default function MesEquipes() {
  return <MainContainer {...headerPersonnalEvalutaion}><MesEquipesPage /></MainContainer>;
}
